/**
 * @desc 分页
 */
const URL = "/rantion-esca";
import http, { updateResponse } from "@/http";
export function request(
  body: defs.esca.EApiRequestParamsDto,
  params: API.esca.eApi.page.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/eApi/page`, {
      method: "POST",
      params,
      data: body,
      ...options,
    }),
  );
}
